var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { http, privateHttp } from '../helpers/Http';
var urlBase = process.env.REACT_APP_API_BASE_URL;
var getOrganizations = function () {
    return privateHttp.get("".concat(urlBase, "/v1/organization"));
};
var getHolders = function (organizationId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/holders"));
};
var getPlans = function (holderId, organizationId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, balance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/balance");
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                balance = (_a.sent()).balance;
                return [2 /*return*/, balance === null || balance === void 0 ? void 0 : balance.map(function (item) { return item.balance.plan.typePlan; })];
        }
    });
}); };
var listOrganizationUsers = function (organizationId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/listuser"));
};
var addToOrganization = function (organizationId, _a) {
    var email = _a.email, lawFirmId = _a.lawFirmId, accessType = _a.accessType;
    return privateHttp.post("".concat(urlBase, "/v1/organization/").concat(organizationId, "/adduser"), {
        username: email,
        organizationLawFirmId: lawFirmId,
        accessType: accessType,
    });
};
var activated = function (organizationId, userId) {
    return privateHttp.put("".concat(urlBase, "/v1/organization/").concat(organizationId, "/user/").concat(userId, "/activate"));
};
var inactivate = function (organizationId, userId) {
    return privateHttp.put("".concat(urlBase, "/v1/organization/").concat(organizationId, "/user/").concat(userId, "/inactivate"));
};
var acceptTerms = function (email, type) {
    return http.post("".concat(urlBase, "/v1/accept-terms"), {
        email: email,
        type: type,
    });
};
var verifyAcceptTerms = function (email) {
    return http.get("".concat(urlBase, "/v1/accept-terms/").concat(email));
};
export var UserService = {
    getOrganizations: getOrganizations,
    getHolders: getHolders,
    getPlans: getPlans,
    listOrganizationUsers: listOrganizationUsers,
    addToOrganization: addToOrganization,
    activated: activated,
    inactivate: inactivate,
    acceptTerms: acceptTerms,
    verifyAcceptTerms: verifyAcceptTerms,
};
